var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _defs;
const _excluded = ["svgRef"];
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
const SvgExamSet = _ref => {
  let {
      svgRef
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.4 8.3H16.7C15.8 8.3 15.1 7.6 15.1 6.7V4L15.2 4.1L19.4 8.3Z",
    fill: "url(#paint0_linear)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.4 8.3V18.4C19.4 19.3 18.7 20 17.8 20H8.89999C7.99999 20 7.29999 19.3 7.29999 18.4V5.6C7.29999 4.7 7.99999 4 8.89999 4H15H15.1V6.7C15.1 7.6 15.8 8.3 16.7 8.3H19.4Z",
    fill: "url(#paint1_linear)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.4 8.3V18.4C19.4 19.3 18.7 20 17.8 20H9.7C8.8 20 8 19.3 8 18.4V5.6C8 4.7 8.8 4 9.7 4H15H15.1V6.7C15.1 7.6 15.8 8.3 16.7 8.3H19.4Z",
    fill: "url(#paint2_linear)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16.7 11H10.8C10.6 11 10.3 10.8 10.3 10.5C10.3 10.2 10.6 10 10.8 10H16.7C17 10 17.2 10.2 17.2 10.5C17.2 10.8 17 11 16.7 11Z",
    fill: "url(#paint3_linear)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M16.7 14H10.8C10.5 14 10.3 13.8 10.3 13.5C10.3 13.2 10.6 13 10.8 13H16.7C17 13 17.2 13.2 17.2 13.5C17.2 13.8 17 14 16.7 14Z",
    fill: "url(#paint4_linear)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M14.2 16.6001H10.8C10.5 16.6001 10.3 16.4001 10.3 16.1001C10.3 15.8001 10.5 15.6001 10.8 15.6001H14.1C14.4 15.6001 14.6 15.8001 14.6 16.1001C14.7 16.4001 14.4 16.6001 14.2 16.6001Z",
    fill: "url(#paint5_linear)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M8.99999 10.1999L8.89999 10.3999L6.79999 9.79992L6.89999 9.49992C7.09999 8.99992 7.69999 8.69992 8.29999 8.79992C8.89999 8.89992 9.19999 9.59992 8.99999 10.1999Z",
    fill: "url(#paint6_linear)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M5.59998 17.8999L6.69998 18.1999L8.69998 11.1999L7.69998 10.8999L5.59998 17.8999Z",
    fill: "url(#paint7_linear)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M4.59998 17.5999L5.59998 17.8999L7.69998 10.8999L6.59998 10.5999L4.59998 17.5999Z",
    fill: "url(#paint8_linear)"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M6.79998 9.7998L8.89998 10.3998L8.69998 11.1998L7.69998 10.8998L6.59998 10.5998L6.79998 9.7998Z",
    fill: "#444447"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M5.59998 17.8999L6.69998 18.1999L5.79998 19.0999L4.79998 18.7999L4.59998 17.5999L5.59998 17.8999Z",
    fill: "url(#paint9_linear)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M4.79999 18.7998L5.79999 19.0998L4.99999 19.9998L4.79999 18.7998Z",
    fill: "black"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 18.8186,
    y1: 4.7101,
    x2: 13.5032,
    y2: 9.5423,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#327BF6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#05007A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear",
    x1: 16.8378,
    y1: 9.0871,
    x2: -0.195712,
    y2: 23.2213,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#327BF6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#05007A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear",
    x1: 17.0008,
    y1: 5.007,
    x2: 2.021,
    y2: 36.8995,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#327BF6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#05007A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear",
    x1: 10.6482,
    y1: 8.6645,
    x2: 32.6347,
    y2: 21.4095,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFDB59"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9238"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear",
    x1: 9.34289,
    y1: 10.9163,
    x2: 31.3294,
    y2: 23.6612,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFDB59"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9238"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear",
    x1: 7.88399,
    y1: 13.4332,
    x2: 29.8705,
    y2: 26.1781,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFDB59"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9238"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear",
    x1: 7.99127,
    y1: 10.5142,
    x2: 7.83105,
    y2: 8.37782,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#90EFFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9342,
    stopColor: "#3C6CF2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3663F1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear",
    x1: 8.96242,
    y1: 11.4035,
    x2: 6.50871,
    y2: 15.7186,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFDB59"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5B82A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear",
    x1: 5.55485,
    y1: 14.2306,
    x2: 7.11194,
    y2: 14.3444,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFDB59"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5B82A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear",
    x1: 6.24631,
    y1: 18.8574,
    x2: 4.52527,
    y2: 17.7196,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFDB59"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1975,
    stopColor: "#FDD354"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5B53F"
  })))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgExamSet, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/ExamSet.748aa4d0.svg";
export { ForwardRef as ReactComponent };